import { useContext } from 'react';
import { ProductContext } from '../../contexts';

interface SpecificationsTable {
  className?: string;
}

const SpecificationsTable: React.FC<SpecificationsTable> = ({ className }) => {
  const { initialSize } = useContext(ProductContext);
  return (
    <>
      <section className={className}>
        <div role="table" className="divide min-w-full divide-y divide-silverGray border border-silverGray">
          <div role="row" className="flex">
            <div role="cell" className="w-[50%] bg-lightSilver p-4 font-semibold">
              Brand
            </div>
            <div role="cell" className="p-4">
              {initialSize?.attributesRaw?.filter((item: any) => item.name === 'brandName')[0]?.value}
            </div>
          </div>
          <div role="row" className="flex">
            <div role="cell" className="w-[50%] bg-lightSilver p-4 font-semibold">
              Color
            </div>
            <div role="cell" className="p-4">
              {initialSize?.attributesRaw?.filter((item: any) => item.name === 'refinementColor')[0]?.value}
            </div>
          </div>
          <div role="row" className="flex">
            <div role="cell" className="w-[50%] bg-lightSilver p-4 font-semibold">
              Material
            </div>
            <div role="cell" className="p-4">
              {initialSize?.attributesRaw?.filter((item: any) => item.name === 'refinementMaterial')[0]?.value}
            </div>
          </div>
          <div role="row" className="flex">
            <div role="cell" className="w-[50%] bg-lightSilver p-4 font-semibold">
              Country of Origin
            </div>
            <div role="cell" className="p-4">
              {initialSize?.attributesRaw?.filter((item: any) => item.name === 'originName')[0]?.value}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SpecificationsTable;
